const Constants = {
    BAR_PADDING: "14px 24px",
    MAIN_COLOR: "rgb(174, 89, 210)",
    TEXTERIFY_PRICING_SITE: "https://texterify.com/pricing",
    TEXTERIFY_NEW_LICENSE_SITE: "https://app.texterify.com/dashboard/settings/licenses",
    GITHUB_ISSUES_SITE: "https://github.com/texterify/texterify/issues"
};

export { Constants };
